"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var typesafe_actions_1 = require("typesafe-actions");
var SfilterAction;
(function (SfilterAction) {
    SfilterAction.CLEAR_CRITERIA = 'CLEAR_CRITERIA';
    SfilterAction.ON_CLOSE_FILTER_CLICK = 'ON_CLOSE_FILTER_CLICK';
    SfilterAction.SET_CONFIRM_COUNT = 'SET_CONFIRM_COUNT';
    SfilterAction.APPLY_CRITERIA = 'APPLY_CRITERIA';
    SfilterAction.clearCriteria = typesafe_actions_1.createAction(SfilterAction.CLEAR_CRITERIA, function (resolve) { return function () { return resolve(); }; });
    SfilterAction.onCloseFilterClick = typesafe_actions_1.createAction(SfilterAction.ON_CLOSE_FILTER_CLICK, function (resolve) { return function () { return resolve(); }; });
    SfilterAction.setConfirmCount = typesafe_actions_1.createAction(SfilterAction.SET_CONFIRM_COUNT, function (resolve) { return function (count) { return resolve(count); }; });
    SfilterAction.applyCriteria = typesafe_actions_1.createAction(SfilterAction.APPLY_CRITERIA, function (resolve) { return function (criteria) { return resolve(criteria); }; });
})(SfilterAction || (SfilterAction = {}));
exports.default = SfilterAction;
